import { ButtonGroup, buttonGroupClasses, styled } from '@mui/material';

import { generateClasses } from '../../../../../../../../utils/helpers';

export const commentActionsClasses = {
  ...generateClasses('CommentActions', ['action']),
};

export const Root = styled(ButtonGroup, {
  shouldForwardProp: (prop) => !['isScreenReaderOn'].includes(prop as string),
})<{ isScreenReaderOn: boolean }>(({ theme, isScreenReaderOn }) => ({
  backgroundColor: theme.palette.background.paper,
  boxShadow: isScreenReaderOn ? 'none' : theme.acadlyShadows.md,
  display: 'flex',
  alignItems: 'stretch',
  gap: 1,
  [`& > *`]: {
    border: isScreenReaderOn ? 'none' : `1px solid ${theme.palette.primary[200]}`,
    borderRadius: 0,
    display: 'flex',
    '&:first-child': {
      borderTopLeftRadius: 4,
      borderBottomLeftRadius: 4,
    },
    '&:last-child': {
      borderTopRightRadius: 4,
      borderBottomRightRadius: 4,
    },
  },
  [`& .${buttonGroupClasses.firstButton}`]: {
    border: `1px solid ${theme.palette.primary[300]}`,
  },
  [`& .${buttonGroupClasses.middleButton}`]: {
    border: `1px solid ${theme.palette.primary[300]}`,
  },
  [`& .${buttonGroupClasses.lastButton}`]: {
    border: `1px solid ${theme.palette.primary[300]}`,
  },
  [`& .${commentActionsClasses.action}`]: {
    /** targeting using ":not" pseudo selector for increasing css specificity inside ButtonGroup  */
    '&:not(:first-of-type)': {
      borderColor: theme.palette.primary[200],
    },
    '&:not(:last-of-type)': {
      borderColor: theme.palette.primary[200],
    },
  },
}));
